import { onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import useAuth from './useAuth'

import useFirestore from './useFirestore'

const useUserProfile = () => {
  const auth = useAuth()
  // const authUser = useAuthUser()
  const firestore = useFirestore()
  const [userProfile, setUserProfile] = useState()
  const setProfileData = (uid) => {
    const docRef = doc(firestore, 'users', uid);
    getDoc(docRef)
      .then(snap => setUserProfile(snap.data()))
      .catch(() => {
        auth.signOut()
      })
  }
  useEffect(() => {
    if (firestore && auth) {
      if (auth.currentUser?.uid) {
        setProfileData(auth.currentUser.uid)
      } else {
        onAuthStateChanged(auth, user => {
          if (user?.uid) {
            setProfileData(user.uid)
          }
        })
      }
    }
  }, [auth, firestore])
  return userProfile
}

export default useUserProfile
